/* Millennio — comportamiento del cajon «¿Cual me rinde mas?»  (ticket #51)
   =======================================================================

   Marcado: snippets/mi-drawer-rinde.liquid
   Datos:   ninguno. Todo el contenido lo pinto Liquid en el servidor a partir
            del titulo y el precio de cada variante. Este archivo solo abre,
            cierra y devuelve el foco.

   BLOQUEO DE SCROLL — por que es asi y no de otra forma
   ----------------------------------------------------
   Ni `overflow:hidden` ni fijar el body. Los dos rompen la cabecera pegajosa de
   esta tienda: `overflow:hidden` en el raiz saca al elemento de su contexto de
   scroll y degrada su position, y fijar el body desplaza el documento entero y
   obliga a restaurar el scroll al cerrar, que es de donde sale el salto al top.
   Y `overflow:hidden` a secas TAMPOCO detiene Lenis: Lenis no lee el scroll del
   documento, mueve el contenido con su propio rAF, asi que sigue corriendo por
   debajo del modal. El bloqueo REAL son dos piezas:
     1. un preventor de `wheel` / `touchmove` / teclas en fase de CAPTURA
     2. `lenis.stop()` mientras el cajon esta abierto, `lenis.start()` al cerrar

   Y no se decide con `closest('[data-lenis-prevent]')`: ese marcador suele
   estar en un host a pantalla completa, con lo que el puntero "sobre la pagina"
   esta en realidad sobre el velo, la comprobacion da positivo y el bloqueo
   nunca actua. Se sube por los ancestros buscando un contenedor REALMENTE
   scrolleable en ESA direccion. Copia deliberada de mi-search.js: dos bloqueos
   distintos en la misma tienda es la deuda que este archivo evita.
*/
(function () {
  'use strict';

  // El <script> lo emite el propio fragmento del cajon. Si algun dia hubiera
  // dos secciones de producto en la misma pagina se cargaria dos veces, y dos
  // delegados en el documento abririan y cerrarian el cajon a la vez.
  if (window.miDrawerRinde) return;
  window.miDrawerRinde = true;

  var abierto = null;      // el host abierto ahora mismo, o null
  var disparador = null;   // a quien le devolvemos el foco al cerrar

  /* ------------------------------------------------------------------ */
  /* Bloqueo de scroll                                                   */
  /* ------------------------------------------------------------------ */

  function scrolleableDebajo(objetivo, direccion) {
    var el = objetivo instanceof Element ? objetivo : null;
    while (el && el !== document.body && el !== document.documentElement) {
      var eje = getComputedStyle(el).overflowY;
      if ((eje === 'auto' || eje === 'scroll') && el.scrollHeight > el.clientHeight + 1) {
        var arriba = el.scrollTop <= 0;
        var abajo = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
        if (direccion < 0) return !arriba;
        if (direccion > 0) return !abajo;
        return true;
      }
      el = el.parentElement;
    }
    return false;
  }

  function frenarRueda(e) {
    if (!scrolleableDebajo(e.target, e.deltaY)) e.preventDefault();
  }

  var yTactil = 0;

  function apuntarTacto(e) {
    if (e.touches && e.touches.length) yTactil = e.touches[0].clientY;
  }

  function frenarTacto(e) {
    if (!e.touches || !e.touches.length) return;
    var delta = yTactil - e.touches[0].clientY;
    if (!scrolleableDebajo(e.target, delta)) e.preventDefault();
  }

  /* Teclas que mueven la pagina cuando el foco no esta en un campo. El
     atrapa-foco cubre el Tab; esto cubre el resto. Las flechas ARRIBA y ABAJO
     estaban fuera de la lista y son justo las que mas mueven: con el cajon
     abierto, 3 pulsaciones de ArrowDown movian la pagina 120px por detras. */
  var TECLAS_SCROLL = [' ', 'PageUp', 'PageDown', 'Home', 'End',
                       'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];

  function frenarTeclas(e) {
    if (TECLAS_SCROLL.indexOf(e.key) === -1) return;
    var t = e.target;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
    if (t && t.closest && t.closest('[data-lenis-prevent]')) return;
    e.preventDefault();
  }

  function bloquearScroll(activo) {
    var metodo = activo ? 'addEventListener' : 'removeEventListener';
    window[metodo]('wheel', frenarRueda, { passive: false, capture: true });
    window[metodo]('touchstart', apuntarTacto, { passive: true, capture: true });
    window[metodo]('touchmove', frenarTacto, { passive: false, capture: true });
    window[metodo]('keydown', frenarTeclas, { capture: true });

    // LENIS. Un overflow:hidden no le hace nada: hay que pararle el rAF.
    // Se busca en los dos sitios donde puede estar publicado.
    var lenis = window.lenis || window.Lenis && window.Lenis.instance || null;
    if (lenis) {
      if (activo && typeof lenis.stop === 'function') lenis.stop();
      if (!activo && typeof lenis.start === 'function') lenis.start();
    }
  }

  /* ------------------------------------------------------------------ */
  /* Foco                                                                */
  /* ------------------------------------------------------------------ */

  function enfocables(host) {
    var panel = host.querySelector('.mi-rinde__panel');
    if (!panel) return [];
    var lista = panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    return Array.prototype.filter.call(lista, function (el) {
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    });
  }

  function atraparFoco(e, host) {
    if (e.key !== 'Tab') return;
    var lista = enfocables(host);
    if (!lista.length) return;
    var primero = lista[0];
    var ultimo = lista[lista.length - 1];
    if (e.shiftKey && document.activeElement === primero) {
      e.preventDefault();
      ultimo.focus();
    } else if (!e.shiftKey && document.activeElement === ultimo) {
      e.preventDefault();
      primero.focus();
    }
  }

  function alPulsarTecla(e) {
    if (!abierto) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      cerrar();
      return;
    }
    atraparFoco(e, abierto);
  }

  /* ------------------------------------------------------------------ */
  /* Abrir / cerrar                                                      */
  /* ------------------------------------------------------------------ */

  /* La invitacion solo es verdad si la variante que mas rinde NO es la que ya
     esta puesta. Si lo es, el boton lo dice y deja de invitar a nada. */
  function actualizarCta(host) {
    var cta = host.querySelector('[data-mi-rinde-elegir]');
    if (!cta) return;
    var pastilla = document.querySelector('[data-mi-pastilla="' + cta.dataset.miRindeElegir + '"]');
    var ya = !!(pastilla && pastilla.classList.contains('is-activa'));
    if (ya && !cta.dataset.miRindeInvita) {
      cta.dataset.miRindeInvita = cta.textContent;   // se guarda para poder volver
    }
    if (ya) {
      cta.textContent = cta.dataset.miRindeYa || cta.textContent;
      cta.classList.add('es-ya');
    } else if (cta.dataset.miRindeInvita) {
      cta.textContent = cta.dataset.miRindeInvita;
      cta.classList.remove('es-ya');
    }
  }

  function abrir(host, origen) {
    if (abierto || !host) return;
    abierto = host;
    disparador = origen || null;
    actualizarCta(host);
    host.classList.add('esta-abierto');
    host.setAttribute('aria-hidden', 'false');
    bloquearScroll(true);
    document.addEventListener('keydown', alPulsarTecla, true);
    // rAF: enfocar algo con visibility:hidden no hace nada, hay que esperar a
    // que el navegador ya lo haya hecho visible.
    requestAnimationFrame(function () {
      var lista = enfocables(host);
      /* El boton de cerrar, se llame como se llame. Estaba fijado a
         `.mi-rinde__cerrar` y por eso el cajon de descripcion (#73), que usa
         su propia piel `.mi-desc`, se abria con el foco todavia en el
         disparador: nadie encontraba a donde llevarlo. `[data-mi-rinde-cerrar]`
         es el contrato de verdad —el mismo atributo que ya cierra— y lo
         cumplen los dos. */
      var meta = host.querySelector('button[data-mi-rinde-cerrar]') || lista[0];
      if (meta) {
        try { meta.focus({ preventScroll: true }); } catch (err) { meta.focus(); }
      }
    });
  }

  function cerrar() {
    var host = abierto;
    if (!host) return;
    abierto = null;
    host.classList.remove('esta-abierto');
    host.setAttribute('aria-hidden', 'true');
    bloquearScroll(false);
    document.removeEventListener('keydown', alPulsarTecla, true);
    // El foco vuelve a quien abrio: si no, quien navega con teclado reaparece
    // al principio del documento.
    if (disparador && document.contains(disparador)) {
      try { disparador.focus({ preventScroll: true }); } catch (err) { disparador.focus(); }
    }
    disparador = null;
  }

  /* ------------------------------------------------------------------ */
  /* Arranque                                                            */
  /* ------------------------------------------------------------------ */

  function montar() {
    document.querySelectorAll('.mi-rinde').forEach(function (host) {
      if (host.dataset.miRindeMontado === '1' && host.parentElement === document.body) return;

      // A <body>, y sin duplicar. El cajon es `position: fixed`: si algun
      // ancestro de la seccion estrena `transform`, `filter` o `perspective`,
      // ese ancestro pasa a ser el bloque contenedor y el cajon aparece DENTRO
      // de la columna del producto en vez de contra la ventana. Colgarlo del
      // body lo hace inmune a eso y le quita de encima cualquier `overflow`
      // intermedio.
      //
      // En el editor la seccion se vuelve a renderizar entera y el gemelo viejo
      // sigue colgado del body: hay que retirarlo o quedarian dos cajones con
      // el mismo id. Y NO se busca con getElementById: el recien renderizado
      // esta ANTES en el documento (dentro de la seccion) que el viejo (ultimo
      // hijo del body), asi que getElementById devolveria el nuevo y el viejo
      // se quedaria. Se barren los hijos directos del body, que es donde solo
      // pueden estar los ya montados.
      document.querySelectorAll('body > .mi-rinde').forEach(function (viejo) {
        if (viejo === host || viejo.id !== host.id) return;
        if (abierto === viejo) cerrar();   // no dejar el bloqueo de scroll puesto
        viejo.remove();
      });
      if (host.parentElement !== document.body) document.body.appendChild(host);
      host.dataset.miRindeMontado = '1';
    });
  }

  /* Delegado en el documento: los disparadores viven en la seccion y el cajon
     en el body, y en el editor los dos pueden reemplazarse en cualquier
     momento. Un solo listener sobrevive a todos esos reemplazos. */
  document.addEventListener('click', function (e) {
    var cerrarlo = e.target.closest && e.target.closest('[data-mi-rinde-cerrar]');
    if (cerrarlo && abierto && abierto.contains(cerrarlo)) {
      e.preventDefault();
      cerrar();
      return;
    }

    // La invitacion: se pulsa la pastilla que YA existe en el selector, que es
    // quien sabe repintar precio, foto y disponibilidad. Si esa pastilla no
    // esta, no se intercepta: el enlace navega y el servidor resuelve.
    var elegir = e.target.closest && e.target.closest('[data-mi-rinde-elegir]');
    if (elegir) {
      var pastilla = document.querySelector('[data-mi-pastilla="' + elegir.dataset.miRindeElegir + '"]');
      if (pastilla) {
        e.preventDefault();
        if (!pastilla.classList.contains('is-activa')) pastilla.click();
        cerrar();
      }
      return;
    }

    var disp = e.target.closest && e.target.closest('[data-mi-rinde]');
    if (!disp) return;
    var host = document.getElementById(disp.getAttribute('aria-controls') || '');
    if (!host) return;   // sin cajon, el enlace hace lo que hacia: navegar
    e.preventDefault();
    abrir(host, disp);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else {
    montar();
  }
  document.addEventListener('shopify:section:load', montar);
})();
